import { useEffect, useRef } from "react";
import { Loader2 } from "lucide-react";
import { usePagedDucks } from "../../hooks/usePagedDucks";
import { DuckCard } from "../DuckCard";

// The Archived tab: ordered ducks that were deleted (kept for a year), 24 per page with infinite scroll.
export const ArchivedDucks = ({ q, actions, reload, enabled }) => {
  const list = usePagedDucks({ path: "/creations/archived/page", pageSize: 24, q, enabled });
  const sentinel = useRef(null);
  const seenReload = useRef(reload);
  const { refresh, hasMore, loadMore } = list;

  useEffect(() => {
    if (reload === seenReload.current) return;
    seenReload.current = reload;
    refresh();
  }, [reload, refresh]);

  useEffect(() => {
    if (!sentinel.current || !hasMore) return undefined;
    const io = new IntersectionObserver((entries) => entries[0].isIntersecting && loadMore(), { rootMargin: "600px" });
    io.observe(sentinel.current);
    return () => io.disconnect();
  }, [hasMore, loadMore]);

  if (!list.items.length && !list.loading) {
    return <div data-testid="my-ducks-empty" className="mt-20 text-center text-muted-foreground">{q ? `No archived ducks match “${q}”.` : "Nothing archived."}</div>;
  }
  return (
    <>
      <div data-testid="my-ducks-grid" className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {list.items.map((c, i) => <DuckCard key={c.id} c={c} i={i} size="lg" variant="archived" actions={actions} />)}
      </div>
      <div ref={sentinel} className="h-10 mt-6 grid place-items-center text-muted-foreground" data-testid="my-ducks-sentinel">
        {(list.loadingMore || (list.loading && !list.items.length)) && <Loader2 className="h-5 w-5 animate-spin" />}
        {!list.hasMore && list.items.length > 0 && <span className="text-xs font-mono2">That's all {list.total} of them.</span>}
      </div>
    </>
  );
};
